import store from '@/store'
import { systemGetAllMenuAndUserHasPrivilege } from '@/util/http'
import router from '@/router'
const hasPermission = (userPermission) => {
  // 当前按钮列表
  var btnPermissionList = []
  btnPermissionList = store.state.nav
  // 过滤
  let eglishPermission = []
  btnPermissionList.map((v) => {
    v.menuArr.map((s) => {
      s.children.map((vals) => {
        eglishPermission.push(vals.priCode)
      })
    })
  })
  // 是否在权限数组里面
  let status = eglishPermission.includes(userPermission)
  return status
}
const routerPermission = (userPermission) => {
  // 过滤
  let routerPermissions = []
  store.state.nav.map((v) => {
    v.menuArr.map((c) => {
      routerPermissions.push(c.path)
    })
  })
  // 是否在权限数组里面
  let routerStatus = routerPermissions.includes(userPermission)
  return routerStatus
}

const titIcon = ['el-icon-s-data', 'el-icon-s-operation', 'el-icon-s-management', 'el-icon-cpu', 'el-icon-s-finance', 'el-icon-s-claim', 'el-icon-collection-tag', 'el-icon-film', 'el-icon-s-marketing', 'el-icon-receiving', 'el-icon-s-opportunity', 'el-icon-truck', 'el-icon-wind-power', 'el-icon-s-tools', 'el-icon-s-custom'] //一级菜单图标
const icon = [
  'el-icon-s-flag',
  'el-icon-s-promotion',
  'el-icon-s-help',
  'el-icon-help',
  'el-icon-s-platform',
  'el-icon-s-shop',
  'el-icon-s-order',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-s-management',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-cpu',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-s-finance',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-s-claim',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-collection-tag',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-film',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-s-marketing',
  'el-icon-s-tools',
  'el-icon-warning',
  'el-icon-receiving',
  'el-icon-user',
  'el-icon-s-custom',
] //二级菜单图标
const routes = []

// 获取菜单权限
function autoGetMenuAuthority(adminId) {
  if (store && store.state.nav.length == 0) {
    systemGetAllMenuAndUserHasPrivilege({ adminId }).then((data) => {
      if (data) {
        let checkedMenu = data.result.userPrivileges
        var menuObjList = []
        data.result.menu.slice(1).map((val, i) => {
          var oneMenu = {}
          oneMenu.menuArr = []
          oneMenu.titId = i.toString()
          oneMenu.titIcon = titIcon[i]
          oneMenu.moduleCode = val.moduleCode
          oneMenu.moduleId = val.moduleId
          oneMenu.titName = val.moduleName
          oneMenu.parentCode = val.parentCode
          val.children.map((vals, index) => {
            var twoMenu = {}
            twoMenu.children = []
            twoMenu.id = vals.moduleCode
            twoMenu.path = '/' + vals.moduleCode
            twoMenu.icon = icon[index]
            twoMenu.moduleId = vals.moduleId
            twoMenu.name = vals.moduleName
            twoMenu.parentCode = vals.parentCode
            vals.children.map((valsp) => {
              for (var i = 0; i < checkedMenu.length; i++) {
                if (checkedMenu[i] == valsp.id) {
                  twoMenu.children.push(valsp)
                }
              }
            })
            if (twoMenu.children.length != 0) {
              oneMenu.menuArr.push(twoMenu)
            }
          })
          if (oneMenu.menuArr.length != 0) {
            menuObjList.push(oneMenu)
          }
        })
        if (menuObjList[menuObjList.length - 1].moduleCode == 'Channel') {
          menuObjList.splice(-1, 1, ...menuObjList.splice(-3, 1, menuObjList[menuObjList.length - 1]))
        }
        store.dispatch('SETNAV', menuObjList)
        // console.log(menuObjList);
        var data = routesData(menuObjList)
        // router.addRoutes(data);
        for (let i = 0; i < data.length; i++) {
          router.addRoute(data[i])
        }
      }
    })
  }
}

function routesData(result) {
  result.map((val) => {
    val.menuArr.map((vals) => {
      routes.push({
        path: vals.path,
        component: () => import('@/views/' + vals.id + '.vue'),
      })
    })
  })
  return routes
}

export default { hasPermission, routerPermission, autoGetMenuAuthority }
